import yup from '../yup-extended';

export const companyNameSchema = yup.string().nullable().trim().label('Firmenname').max(128);
export const registrationNumberSchema = yup.string().nullable().trim().label('Registernummer').max(50);
export const registrationLocationSchema = yup.string().nullable().trim().label('Registerort').max(50);
export const legalFormSchema = yup
    .number()
    .nullable()
    .label('Rechtsform')
    .transform((value) => (value === null ? undefined : value));
